function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "./node_modules/@angular/core/src/linker async recursive";



//////////////////
// WEBPACK FOOTER
// ./~/@angular/core/src/linker async
// module id = ./node_modules/@angular/core/src/linker async recursive
// module chunks = 0